import React from "react";
import LayerItem from "./LayerItem";
import Paginator from "../../common/component/Paginator";
import DataSetFilterItem from "../../filter/DataSetFilter/dto/DataSetFilterItem";

interface ItemListProps {
    id: string;
    position: {
        startItem: number;
        endItem: number;
        pageNumber: number;
        totalPages: number;
    };
    visibleItems: DataSetFilterItem[];
    hiddenItems: DataSetFilterItem[];
    onAdd?: (filterId: string) => void;
    onPageChange: (pageNumber: number) => void;
    className: string;
}

const ItemList = (props: ItemListProps) => {
    const endItem = props.position.endItem || props.visibleItems.length;

    const rows = props.visibleItems
        .slice(props.position.startItem, endItem)
        .map((item) => (
            <LayerItem
                key={props.id + item.id}
                className={props.className}
                itemVisible={props.hiddenItems.includes(item.id)}
                onAdd={props.onAdd}
                item={item}
            />
        ));
    return (
        <div className={"itemList"}>
            <div id={props.id + "List"}>{rows}</div>
            <Paginator
                onPageChange={props.onPageChange}
                pageNumber={props.position.pageNumber}
                totalPages={props.position.totalPages}
            />
        </div>
    );
};

ItemList.defaultProps = {
    position: {
        startItem: 0,
        pageNumber: 1,
        totalPages: 1,
    },
};

export default ItemList;
